import { render } from "./resultCompleteTask.vue?vue&type=template&id=f2b858c4&scoped=true"
import script from "./resultCompleteTask.vue?vue&type=script&lang=js"
export * from "./resultCompleteTask.vue?vue&type=script&lang=js"

import "./resultCompleteTask.vue?vue&type=style&index=0&id=f2b858c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b858c4"]])

export default __exports__